import { patientApi } from '@/api/PatientApi'
import { useQuery } from '@tanstack/react-query'

/** Exported so the order mutation can make this stale without importing the hook itself. */
export const WHITENING_SUMMARY_QUERY_KEY = ['whitening-summary']

/**
 * Where the member's whitening kit is, and what they may order next.
 *
 * Read on Home as well as on the kit's own page, so it is cached rather than fetched twice;
 * refetched on focus because the states that move — being made, shipped, delivered — move while
 * the app is in somebody's pocket, and coming back to it is exactly when they want to know.
 */
const useFetchWhiteningSummary = () => {
	const { data, isLoading, isError, refetch } = useQuery({
		queryKey: WHITENING_SUMMARY_QUERY_KEY,
		queryFn: () => patientApi.getWhiteningSummary(),
		refetchOnWindowFocus: true,
	})

	return { summary: data, isLoading, isError, refetch }
}

export { useFetchWhiteningSummary }
